var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "eggs",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eieren") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eieren",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1550778,38.2560889 C44.1410161,38.2424846 44.1300225,38.2273686 44.1172391,38.2127566 C44.1157051,38.2117488 44.1136598,38.2109931 44.1123815,38.2097334 L44.1550778,38.2560889 Z M50.0001278,55.9346614 C42.3334532,55.9346614 36.0959549,49.7882763 36.0959549,42.2330875 C36.0959549,38.1734552 37.8674688,32.40522 40.5039029,27.8797655 C43.3975376,22.9134299 46.8587522,20.0653386 50.0001278,20.0653386 C54.7000471,20.0653386 59.0338519,25.6300127 61.5733883,31.8308151 L56.5431477,37.7494536 L50.567452,31.5771195 C50.4079161,31.3992555 50.1783275,31.2972231 49.9377452,31.2964673 C49.6971629,31.2959634 49.4673186,31.397492 49.30676,31.5743483 L44.0868148,37.3420796 C43.8781908,37.6645525 43.9170522,37.9837504 44.1172391,38.2127566 C44.3573101,38.4069962 44.7397873,38.3525788 45.0376389,38.0590781 L49.9326318,33.2114024 L55.9088389,40.0478293 C56.0678635,40.2259452 56.2977078,40.3284815 56.5380344,40.3284815 L56.5405911,40.3284815 C56.780662,40.3284815 57.0094836,40.2274568 57.1692753,40.0508525 L62.5441544,34.5005385 C63.4113756,37.2239235 63.9043008,39.9352157 63.9043008,42.2330875 C63.9043008,49.7882763 57.6670582,55.9346614 50.0001278,55.9346614 Z M61.559071,27.0106 C58.264551,21.1997884 54.1595679,18 50.0001278,18 C46.0303924,18 42.0123359,21.1438595 38.6861133,26.851379 C35.8832403,31.6627764 34,37.8441801 34,42.2328356 C34,50.9267571 41.1778401,58 50.0001278,58 C58.8224156,58 66,50.9267571 66,42.2328356 C66,37.6748817 64.2985387,31.8416481 61.559071,27.0106 L61.559071,27.0106 Z",
    id: "Fill-1",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    xmlSpace: "preserve",
    x: 22,
    y: 101,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "eieren"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggs);
export default __webpack_public_path__ + "static/media/eggs.cefeee7f771761cbe7d130484f1905da.svg";
export { ForwardRef as ReactComponent };